import { IconProps } from "../../utils/global-types/global-types";

const DocumentTextIcon = ({ className, ...rest }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 12 12"
    className={className ? className : "w-[12px] h-[12px]"}
    {...rest}
  >
    <path
      fill="currentColor"
      d="M8 1H4C2.25 1 1.5 2 1.5 3.5v5C1.5 10 2.25 11 4 11h4c1.75 0 2.5-1 2.5-2.5v-5C10.5 2 9.75 1 8 1M4 6.125h2c.205 0 .375.17.375.375s-.17.375-.375.375H4a.38.38 0 0 1-.375-.375c0-.205.17-.375.375-.375m4 2.75H4a.38.38 0 0 1-.375-.375c0-.205.17-.375.375-.375h4c.205 0 .375.17.375.375s-.17.375-.375.375m1.25-4.25h-1c-.76 0-1.375-.615-1.375-1.375v-1c0-.205.17-.375.375-.375s.375.17.375.375v1c0 .345.28.625.625.625h1c.205 0 .375.17.375.375s-.17.375-.375.375"
    ></path>
  </svg>
);

export default DocumentTextIcon;
